import React from 'react';
import { Link } from 'react-router-dom';

import Image from '../../assets/img/service/service-2-1.jpg';

const SingleServiceTwo = (props) => {
  const { itemClass, serviceImage, title, description, btnText } = props;
  return (
    <div className={itemClass ? itemClass : 'it-service-2-item'}>
      <div className="it-service-2-thumb">
        <img src={serviceImage ? serviceImage : Image} alt="" />
      </div>
      <div className="it-service-2-content">
        <h4 className="it-service-title mb-15">
          <Link className="hover-anim" to="/service-details">
            {title ? title : 'Implants'}
          </Link>
        </h4>
        <p className="mb-15">
          {description
            ? description
            : 'nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia'}
        </p>
        <Link className="hover-anim" to="/service-details">
          {btnText ? btnText : 'Learn More'}{' '}
          <i className="flaticon-right-arrow"></i>
        </Link>
      </div>
    </div>
  );
};

export default SingleServiceTwo;
